<template>
  <div class="masiva-summary">
    <template v-if="esResultado">
      <el-alert
        data-test="resumen-lote"
        :type="alertTypeLote"
        :closable="false"
        show-icon
      >
        <template #title>
          Lote Nº {{ store.resumenLote.numeroLote }}: Se procesaron
          {{ store.resumenLote.procesadas }}, se generaron {{ store.resumenLote.generadas }},
          fallaron {{ store.resumenLote.fallidas }}.
        </template>
      </el-alert>
      <div class="masiva-summary__cards">
        <el-card shadow="never">
          <el-statistic
            data-test="procesadas"
            title="Procesadas"
            :value="store.resumenLote.procesadas"
          />
        </el-card>
        <el-card shadow="never">
          <el-statistic
            data-test="generadas"
            title="Cotizaciones generadas"
            :value="store.resumenLote.generadas"
            value-style="color: #67c23a"
          />
        </el-card>
        <el-card shadow="never">
          <el-statistic
            data-test="fallidas"
            title="Fallaron"
            :value="store.resumenLote.fallidas"
            value-style="color: #f56c6c"
          />
        </el-card>
      </div>
      <p
        v-if="store.resumenLote.noEnviadas > 0"
        data-test="no-enviadas"
        class="masiva-summary__note"
      >
        {{ store.resumenLote.noEnviadas }} fila(s) no se enviaron por errores de validación.
      </p>
    </template>
    <template v-else>
      <div class="masiva-summary__cards">
        <el-card shadow="never">
          <el-statistic
            data-test="total"
            title="Filas totales"
            :value="store.resumen.total"
          />
        </el-card>
        <el-card shadow="never">
          <el-statistic
            data-test="correctas"
            title="Correctas"
            :value="store.resumen.correctas"
            value-style="color: #67c23a"
          />
        </el-card>
        <el-card shadow="never">
          <el-statistic
            data-test="erroneas"
            title="Con errores"
            :value="store.resumen.erroneas"
            value-style="color: #f56c6c"
          />
        </el-card>
      </div>
      <el-alert
        :type="store.hayErrores ? 'warning' : 'success'"
        :title="alertTitle"
        :closable="false"
        show-icon
      />
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useCotizacionMasivaStore } from '../stores/cotizacion_masiva_store.js';

const store = useCotizacionMasivaStore();

const esResultado = computed(() => store.fase === 'resultado');

const alertTypeLote = computed(() => {
  const { estado } = store.resumenLote;
  if (estado === 'COMPLETADO') return 'success';
  return estado === 'PROCESANDO' ? 'info' : 'warning';
});

const alertTitle = computed(() =>
  store.hayErrores
    ? 'Hay filas con errores. Revisá la tabla y luego usá «Decidir cómo continuar» para cancelar o procesar solo las correctas.'
    : 'Todas las filas son correctas.',
);
</script>

<style scoped>
.masiva-summary {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.masiva-summary__cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
}

.masiva-summary__note {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
}
</style>
